import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Selectors
import { makeSelectTimesheetValue } from '../../../../../../../../../../services/timesheets/selectors';

interface Props {
    groupName?: ?string;
}

export class TimesheetGroupName extends React.PureComponent<Props> {
    render() {
        const { groupName } = this.props;
        if (!groupName) return null;
        return groupName;
    }
}

const mapStateToProps = createStructuredSelector({
    groupName: makeSelectTimesheetValue('groupName')
});

export default connect(mapStateToProps)(TimesheetGroupName);
